import { kpiSlice, DEFAULT_KPI_STATE, KPI_PREFERENCE_SUBTYPE_BASE, KPI_PREFERENCE_FIELDS, selectKPIPanel } from "../store/kpi-slice"
import { createSyncPreferencesHook } from "./create-sync-preferences-hook"

const useSyncKPIPreferencesBase = createSyncPreferencesHook({
  selectPanelState: selectKPIPanel,
  defaultState: DEFAULT_KPI_STATE,
  preferenceBase: KPI_PREFERENCE_SUBTYPE_BASE,
  preferenceFields: KPI_PREFERENCE_FIELDS,
  setPreferences: (dashboardId, panelId, prefs) =>
    kpiSlice.actions.setPreferences({ dashboardId, panelId, ...prefs }),
  clearPendingClonePersist: (dashboardId, panelId) =>
    kpiSlice.actions.clearPendingClonePersist({ dashboardId, panelId }),
})

interface UseSyncKPIPreferencesOptions {
  /** Tab to seed a fresh panel with, from `module.config.initialTab`. The default layout has a
   *  summary panel and a decisions panel, so this is applied per panel and must not be overridden
   *  by the legacy/base record (hence omitFallbackKeys on selectedTab). The actual seed happens in
   *  useKPIData (initFromModuleConfig, before this sync) — here we only protect it from the fallback. */
  initialTab?: string
}

/**
 * Per-panel sync. Called from KPIWrapper (inside a PanelIdProvider), NOT from the dashboard-level
 * useDashboardPreferencesSync — KPI preferences are scoped per panel ("kpi.{panelId}"), with the
 * un-suffixed "kpi" key read once as a legacy fallback. Returns the slice flag.
 */
export function useSyncKPIPreferences({ initialTab }: UseSyncKPIPreferencesOptions = {}): boolean {
  return useSyncKPIPreferencesBase(() => ({
    // Module config provided the tab — don't let the legacy/base record's selectedTab override it.
    ...(initialTab != null && { omitFallbackKeys: ["selectedTab"] }),
  }))
}
